export const PO_LINE_FIELD_NAMES = {
  isBinderyActive: 'details.isBinderyActive',
  orderFormat: 'physical.createInventory',
  receivingWorkflow: 'checkinItems',
};
